import RichText from 'components/shared/richtext';
import styles from './faqHubContent.module.scss';

const FaqHubContent = ({ data, locale }) => {
  if (!data) return null;

  const { title, intro } = data;

  return (
    <div className={styles.hub}>
      {title && <h1 className={styles.title}>{title}</h1>}
      {intro?.json && (
        <div className={styles.intro}>
          <RichText text={intro.json} links={intro.links} locale={locale} />
        </div>
      )}
    </div>
  );
};

export default FaqHubContent;
